import React from 'react';
export function AnimatedGradient() {
  return <div className="fixed inset-0 w-full h-full -z-10 animate-gradient-slow opacity-90" style={{
    background: 'linear-gradient(-45deg, #fdba74, #fda4af, #f9a8d4, #c4b5fd, #93c5fd)',
    backgroundSize: '400% 400%'
  }} data-id="element-10" />;
}